(function () {
  'use strict';

  const SESSION_KEY = 'delivery_region_cache';

  function getWarehouseDate() {
    const now = new Date();

    const madridTimeParams = {
      timeZone: "Europe/Madrid",
      year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', minute: 'numeric', second: 'numeric',
      hour12: false
    };
    const formatter = new Intl.DateTimeFormat('en-US', madridTimeParams);
    const parts = formatter.formatToParts(now);
    const getPart = (type) => parseInt(parts.find(p => p.type === type).value, 10);

    return new Date(
      getPart('year'), getPart('month') - 1, getPart('day'),
      getPart('hour'), getPart('minute'), getPart('second')
    );
  }

  function isNonBusiness(date, holidays) {
    const day = date.getDay();
    const isoDate = date.toISOString().split('T')[0];
    return day === 0 || day === 6 || holidays.includes(isoDate);
  }

  function getNextBusinessDay(date, holidays) {
    let d = new Date(date);
    d.setDate(d.getDate() + 1);
    while (isNonBusiness(d, holidays)) {
      d.setDate(d.getDate() + 1);
    }
    return d;
  }

  function addBusinessDays(startDate, daysToAdd, holidays) {
    let currentDate = new Date(startDate);
    let added = 0;
    let safetyLoop = 0;

    while (added < daysToAdd && safetyLoop < 60) {
      currentDate.setDate(currentDate.getDate() + 1);
      if (!isNonBusiness(currentDate, holidays)) {
        added++;
      }
      safetyLoop++;
    }
    return currentDate;
  }

  function formatCompactRange(dateStart, dateEnd, locale) {

    const dayFormat = new Intl.DateTimeFormat(locale, { weekday: 'short' });
    const monthFormat = new Intl.DateTimeFormat(locale, { month: 'short' });

    const clean = (str) => str.replace('.', '');

    const formatDay = (d) => {
      const name = clean(dayFormat.format(d));
      const num = d.getDate();
      const month = clean(monthFormat.format(d));

      return {
        name: name.charAt(0).toUpperCase() + name.slice(1),
        num,
        month: month.charAt(0).toUpperCase() + month.slice(1)
      };
    };

    const d1 = formatDay(dateStart);
    const d2 = formatDay(dateEnd);

    if (d1.num === d2.num && d1.month === d2.month) {
      return `<span class="delivery-highlight">${d1.name} ${d1.num} ${d1.month}</span>`;
    }

    let htmlResult = "";
    if (d1.month === d2.month) {

      htmlResult = `${d1.name} ${d1.num} – ${d2.name} ${d2.num} ${d1.month}`;
    } else {

      htmlResult = `${d1.name} ${d1.num} ${d1.month} – ${d2.name} ${d2.num} ${d2.month}`;
    }

    return `<span class="delivery-highlight">${htmlResult}</span>`;
  }

  async function detectRegion(config) {
    const countryCode = String(config.countryCode || '').toUpperCase();

    if (config.enableApi !== true) {
      console.debug('Delivery API disabled by config');
      return null;
    }

    if (window.Shopify && window.Shopify.customerPrivacy) {
      const privacy = window.Shopify.customerPrivacy;

      if (typeof privacy.analyticsProcessingAllowed === 'function') {
        const allowed = await Promise.resolve(privacy.analyticsProcessingAllowed());
        if (!allowed) {
          console.debug('Delivery geo-detection skipped: Consent not granted.');
          return null;
        }
      }
    }

    if (config.userRegionCode) return config.userRegionCode;

    const cached = sessionStorage.getItem(SESSION_KEY);
    if (cached) return cached;

    if (countryCode === 'ES') {
      try {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 2000);

        const response = await fetch('https://ipapi.co/json/', {
          signal: controller.signal,
          method: 'GET',
          referrerPolicy: 'no-referrer',
          credentials: 'omit'
        });
        clearTimeout(timeoutId);

        if (!response.ok) throw new Error("API Error");

        const data = await response.json();
        let detected = null;

        if (data.region_code === 'IB' || data.region === 'Balearic Islands') detected = 'BALEARES';
        if (data.region_code === 'CN' || data.region === 'Canary Islands') detected = 'CANARIAS';

        if (detected) {
          sessionStorage.setItem(SESSION_KEY, detected);
          return detected;
        }
      } catch (e) {
        console.debug('Geo-detection skipped:', e.message);
      }
    }
    return null;
  }

  async function init() {
    const config = window.DeliveryConfig;
    if (!config) return;

    const resultEl = document.getElementById('delivery-result');
    const wrapperEl = document.querySelector('.delivery-promise-wrapper');

    if (!resultEl) return;

    const countryCode = String(config.countryCode || '').toUpperCase();
    const allowedCountryCodes = config.allowedCountryCodes || Object.keys(config.zones || {});

    if (allowedCountryCodes.length && !allowedCountryCodes.includes(countryCode)) {
      if (wrapperEl) wrapperEl.remove();
      return;
    }

    const render = (regionCode) => {

      const activeZoneKey = regionCode || countryCode;
      const zone = config.zones[activeZoneKey];

      if (!zone) {
        if (wrapperEl) wrapperEl.remove();
        return;
      }

      const nowMadrid = getWarehouseDate();

      let processingDate;

      if (isNonBusiness(nowMadrid, config.holidays)) {

        processingDate = getNextBusinessDay(nowMadrid, config.holidays);
      } else {

        if (nowMadrid.getHours() < zone.cutOffHour) {

          processingDate = nowMadrid;
        } else {

          processingDate = getNextBusinessDay(nowMadrid, config.holidays);
        }
      }

      const [minTransit, maxTransit] = zone.leadTime.before;

      const startDelivery = addBusinessDays(processingDate, minTransit, config.holidays);
      const endDelivery = addBusinessDays(processingDate, maxTransit, config.holidays);

      const dateHtml = formatCompactRange(startDelivery, endDelivery, config.locale);

      resultEl.innerHTML = `<span class="delivery-text" style="color:#121212; margin-right:4px;">${config.translations.receiveIt || 'Recíbelo'}:</span><span class="delivery-date-text">${dateHtml}</span>`;

    };

    render(config.userRegionCode);
    if (wrapperEl) wrapperEl.style.opacity = '1';

    if (!config.userRegionCode && countryCode === 'ES') {
      const region = await detectRegion(config);
      if (region) render(region);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
